// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.yW4zjwQblJ7Nth {
  border-radius: var(--ds-border-radius-100, 3px);
  background-color: var(--ds-surface, #ffffff);
  background-repeat: no-repeat;
  cursor: progress;
  background-origin: border-box;
  animation-name: DNfPZJWQLwz5mb;
  animation-duration: 1.5s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  width: 120px;
  height: 16px;
  margin-top: var(--ds-space-200, 16px);
  margin-bottom: var(--ds-space-100, 8px);
}
@keyframes DNfPZJWQLwz5mb {
  from {
    background-color: var(--ds-skeleton, #091e420f);
  }
  to {
    background-color: var(--ds-skeleton-subtle, #091e4208);
  }
}
@media (prefers-reduced-motion: reduce) {
  .yW4zjwQblJ7Nth {
    animation: none;
  }
}
.MP320o7pEu6E8Y {
  border-radius: var(--ds-border-radius-100, 3px);
  background-color: var(--ds-surface, #ffffff);
  background-repeat: no-repeat;
  cursor: progress;
  background-origin: border-box;
  animation-name: DNfPZJWQLwz5mb;
  animation-duration: 1.5s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  height: 72px;
  margin-top: var(--ds-space-050, 4px);
  margin-bottom: var(--ds-space-150, 12px);
}
@keyframes DNfPZJWQLwz5mb {
  from {
    background-color: var(--ds-skeleton, #091e420f);
  }
  to {
    background-color: var(--ds-skeleton-subtle, #091e4208);
  }
}
@media (prefers-reduced-motion: reduce) {
  .MP320o7pEu6E8Y {
    animation: none;
  }
}
`, ""]);
// Exports
export var skeletonHeaderText = `yW4zjwQblJ7Nth`;
export var shimmer = `DNfPZJWQLwz5mb`;
export var skeletonTitleInput = `MP320o7pEu6E8Y`;
export default ___CSS_LOADER_EXPORT___;
